import React from 'react';
import { useSwipeable } from 'react-swipeable';

import { RIGHT_DIR, LEFT_DIR, DISABLE_SWIPE } from '../utilities/enums';

export const Swipe = ({ children, onSwipe }) => {
  const handlers = useSwipeable({
    onSwipedRight: (event) => {
      handleSwipe(event, () => onSwipe(RIGHT_DIR));
    },
    onSwipedLeft: (event) => {
      handleSwipe(event, () => onSwipe(LEFT_DIR));
    },
    trackMouse: true,
    delta: 150,
    swipeDuration: 300,
  });

  const getAllParentElements = (element) => {
    const parents = [];
    let currentElement = element;

    while (currentElement.parentElement) {
      parents.push(currentElement.parentElement);
      currentElement = currentElement.parentElement;
    }

    return parents;
  };

  const handleSwipe = (event, callback) => {
    const parents = getAllParentElements(event.event.target);
    const elements = [...parents, event.event.target];
    const disabled = elements.some((element) =>
      element.className.includes(DISABLE_SWIPE)
    );
    if (!disabled) {
      callback();
    }
  };

  return (
    <div className="swipe" style={{ height: '100%' }} {...handlers}>
      {children}
    </div>
  );
};
